import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getLogoutCause } from 'src/modules/third-party-login/third-party-login-component-api';
import { LogoutCause } from 'src/modules/axios-interceptor';
import { AuthContext } from 'src/context/ute-auth-context/auth-provider';

const Logout = () => {
	const navigate = useNavigate();
	const auRegistrationId = Number(useParams().auRegistrationId ?? 0);
	const companyId = Number(useParams().companyId ?? 0);
	const { updateAuthToken, updateRefreshToken } = useContext(AuthContext);
	useEffect(() => {
		updateAuthToken('');
		updateRefreshToken('');
		localStorage.removeItem('sessionEndTime');
		getLogoutCause(companyId, auRegistrationId, (logoutCause) => {
			if (logoutCause === LogoutCause.LinkExpired) {
				navigate('/access-denied');
			} else {
				navigate('/logged-out');
			}
		});
	}, [auRegistrationId, companyId]);

	return null;
};

export default Logout;